<template>
  <div
    class="h-full grid gap-x-3 overflow-hidden bg-gray-100 rounded-lg p-2.5"
    style="grid-template-columns: 1fr 300px"
  >
    <div
      class="grid gap-y-3 overflow-hidden"
      style="grid-template-rows: 180px 1fr"
    >
      <div class="bg-white rounded-lg p-2.5 grid grid-rows-2">
        <div class="grid grid-cols-4 border-b border-gray-100">
          <div
            class="border-r flex flex-col gap-y-3 justify-center px-5 pb-2.5 border-gray-100"
          >
            <c_titles value1="总应收" value2="欠款" />
            <div class="flex items-end">
              <c_money value="0" bold :size="18" color="#080" />
              <text
                class="text-gray-400"
                style="font-size: 12px; line-height: 12px"
              >
                {{ "/" + $numberFormat(0) }}
              </text>
            </div>
          </div>
          <div
            class="border-r flex flex-col gap-y-3 justify-center px-5 pb-2.5 border-gray-100"
          >
            <c_titles value1="会议预算" value2="实际成本" />
            <div class="flex items-end">
              <c_money :value="0" bold :size="18" color="#1e90ff" />
              <text
                class="text-gray-400"
                style="font-size: 12px; line-height: 12px"
              >
                {{ "/" + $numberFormat(0) }}
              </text>
            </div>
          </div>
          <div
            class="border-r flex flex-col gap-y-3 justify-center px-5 pb-2.5 border-gray-100"
          >
            <c_titles value1="会议费用" value2="未付" />
            <div class="flex items-end">
              <c_money :value="0" :size="18" color="#333" />
              <text
                class="text-gray-400"
                style="font-size: 12px; line-height: 12px"
              >
                {{ "/" + $numberFormat(0) }}
              </text>
            </div>
          </div>
          <div
            class="flex flex-col gap-y-3 justify-center px-5 pb-2.5 border-gray-100"
          >
            <c_titles value1="采购费用" value2="未付" />
            <div class="flex items-end">
              <c_money :value="0" :size="18" color="#333" />
              <text
                class="text-gray-400"
                style="font-size: 12px; line-height: 12px"
              >
                {{ "/" + $numberFormat(0) }}
              </text>
            </div>
          </div>
        </div>
        <div class="huiyi-detail-more-box-t">
          <div>
            <li>物料筹备</li>
            <li>--</li>
          </div>
          <div>
            <li>报名人数</li>
            <li>--</li>
          </div>
          <div>
            <li>参会人数</li>
            <li>--</li>
          </div>
          <div>
            <li>需接机</li>
            <li>--</li>
          </div>
          <div>
            <li>需住宿</li>
            <li>--</li>
          </div>
          <div>
            <li>签到场次</li>
            <li>--</li>
          </div>
        </div>
      </div>
      <div class="bg-white rounded-lg p-2.5 flex flex-col overflow-hidden">
        <ul class="border-b border-gray-100 font-bold text-sm pb-2.5">
          会议日志
        </ul>
        <div class="flex-1 overflow-y-auto mt-2.5">
          <div
            class="border-b border-gray-100 px-2.5 pb-2.5 mb-2.5 flex flex-col gap-y-2"
            v-for="item in state.log_data"
            :key="item"
          >
            <ul class="flex items-center gap-x-5">
              <strong>{{ item.create_time }}</strong>
              <c_status showBg arrName="HuiYi_CaoZuo_Type" :value="1" />
            </ul>
            <ul class="text-xs text-gray-500">
              今日整体筹备进度达 65%，较昨日提升 8%。会务执行岗完成主会场及 3
              个分会场议程初稿，对接 9
              位核心嘉宾确认发言细节，完成会场勘测与布置规划，剩余 3
              位嘉宾未确认档期。会议计调岗完成核心物料、酒店房间及车辆采购签约，资源已归属会议项目，建立
              350
              元应急备用金台账。项目统筹岗审核主会场议程并提出修改意见，核对采购成本未超预算。财务岗审核采购凭证并录入系统，代管应急备用金。待协调问题包括
              3
              位嘉宾档期确认、酒店房间调整、分会场音响调试费。明日重点跟进嘉宾档期，推动待协调问题解决，完成议程终稿编制。
            </ul>
            <ul class="flex flex-wrap gap-3">
              <el-image
                v-for="(item, index) in 10"
                :key="item"
                :src="require('@/assets/images/login.png')"
                :preview-src-list="[
                  require('@/assets/images/login.png'),
                  require('@/assets/images/login.png'),
                  require('@/assets/images/login.png'),
                  require('@/assets/images/login.png'),
                ]"
                :initial-index="index"
                class="w-24 h-14 rounded"
              />
            </ul>
            <ul class="flex items-end text-gray-400 text-xs gap-x-2">
              <text class="text-sm text-gray-600">张小飞</text>
              <text>服务部</text>
              <text class="ml-1">2025-12-24 18:24:15 创建</text>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white rounded-lg p-2.5 flex flex-col overflow-hidden">
      <ul class="font-bold text-sm pb-2.5">
        会议日程
      </ul>
      <div
        v-if="state.rc_data?.length > 0"
        class="overflow-y-auto py-7 px-2.5 rounded-lg"
        style="background: linear-gradient(to bottom, #e9f4fe, #fff, #eefbf8)"
      >
        <div v-for="(item, index) in state.rc_data" :key="item" class="mb-5">
          <ul class="flex items-center gap-x-2 text-sm">
            <div class="c-icon-trigon-r" style="--size: 10"></div>
            <strong style="color: #414a96">
              {{ "DAY" + (index + 1).toString().padStart(2, "0") }}
            </strong>
            <text class="font-bold">{{ item.date }}</text>
          </ul>
          <div class="text-xs my-3 font-bold">
            {{ item.meetingPlace?.name }}
          </div>
          <div
            style="grid-template-columns: 0.7fr 1fr"
            class="p-2 grid text-xs rounded bg-blue-100 items-center"
          >
            <li style="min-width: 0">
              {{
                $dayjs(item.start_time, "HH:mm:ss").format("HH:mm") +
                " ~ " +
                $dayjs(item.end_time, "HH:mm:ss").format("HH:mm")
              }}
            </li>
            <div class="flex gap-x-1 items-center">
              <text style="color: #063f94">●</text>
              <li
                class="text-xs font-bold cursor-pointer"
                style="color: #063f94"
              >
                {{ item.name }}
              </li>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center" v-else style="max-height: 70%">
        <el-image
          :src="require('@/assets/images/nodata.png')"
          style="width: 80%"
        />
        <el-button link type="primary" :icon="Plus" @click="toRiCheng">
          去添加
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { meeting_schedule_page, meeting_log_page } from "@/http/meeting";
export default {
  props: { model: Object },
  setup(props, { emit }) {
    const state = reactive({});
    onMounted(() => {
      onLoadRc();
      onLoadLog();
    });

    //加载日程
    const onLoadRc = () => {
      meeting_schedule_page({
        meeting_id: props.model?.id,
        limit: 0,
        sort_field: "date",
        sort_value: "asc",
      }).then((res) => {
        if (res.status == 200) state.rc_data = res.data.data?.list;
      });
    };

    const onLoadLog = () => {
      meeting_log_page({
        meeting_id: props.model?.id,
        limit: 0,
      }).then((res) => {
        if (res.status == 200) state.log_data = res.data.data?.list;
      });
    };

    //跳转到日程
    const toRiCheng = () => {
      emit("toRiCheng");
    };
    return { state, props, toRiCheng };
  },
};
</script>

<style lang="scss" scoped>
.huiyi-detail-more-box-t {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  padding-top: 10px;

  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    row-gap: 10px;

    & > li:first-child {
      color: #a2a2a2;
      font-size: 80%;
    }

    & > li:last-child {
      font-weight: 600;
    }
  }
}
</style>
